import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ClientTopNav from "./ClientTopNav"; // ✅ No progress bar

export default function WelcomeChoice() {
  const navigate = useNavigate();
  const location = useLocation();
  const qs = location.search || "";

  return (
    <>
      {/* ✅ Client Header (no progress bar) */}
      <ClientTopNav />

      {/* Background wrapper */}
      <div style={{ background: "#f9fafb" }}>
        
        {/* ✅ Controls vertical positioning */}
        <div style={{ paddingTop: 70 }} />  {/* ← adjust 60–90 if needed */}

        <div
          style={{
            padding: "0 20px 80px",
            maxWidth: 980,
            margin: "0 auto",
          }}
        >
          <h1
            style={{
              fontSize: 38,
              fontWeight: 900,
              margin: "0 0 12px",
              color: "#141414",
            }}
          >
            What are you looking to do?
          </h1>

          <p
            style={{
              margin: "0 0 32px",
              color: "#555",
              fontSize: 16,
            }}
          >
            Choose the option that best matches your situation.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: 24,
            }}
          >
            {/* REFINANCE */}
            <div
              style={{
                background: "white",
                padding: 28,
                borderRadius: 20,
                boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              <h3 style={{ margin: "0 0 10px", fontSize: 28 }}>
                Refinance My Loan
              </h3>

              <p style={{ color: "#666", margin: "0 0 24px" }}>
                Review your interest rate, access equity, or consolidate debts.
              </p>

              <button
                onClick={() => navigate(`/refinance${qs}`)}
                style={{
                  width: "100%",
                  height: 54,
                  borderRadius: 16,
                  border: "none",
                  fontWeight: 800,
                  cursor: "pointer",
                  background: "#4EDCF6",
                  color: "#141414",
                  fontSize: 16,
                }}
              >
                Start Refinance
              </button>
            </div>

            {/* PURCHASE */}
            <div
              style={{
                background: "white",
                padding: 28,
                borderRadius: 20,
                boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
                border: "1px solid rgba(0,0,0,0.06)",
              }}
            >
              <h3 style={{ margin: "0 0 10px", fontSize: 28 }}>
                Buy a Property
              </h3>

              <p style={{ color: "#666", margin: "0 0 24px" }}>
                First home, next home, or investment property.
              </p>

              <button
                onClick={() => navigate(`/purchase${qs}`)}
                style={{
                  width: "100%",
                  height: 54,
                  borderRadius: 16,
                  border: "none",
                  fontWeight: 800,
                  cursor: "pointer",
                  background: "#141414",
                  color: "white",
                  fontSize: 16,
                }}
              >
                Start Purchase
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}